import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { RootState } from '../redux/store';
import { accessTokenSuccess, logout } from '../redux/auth/authSlice';
import { refreshAccessToken } from '../helpers/api/auth';

const LoginHelper: React.FC<{}> = () => {
    const stayLoggedInUntil = 1800;
    const refreshAt = 30;

    const dispatch = useDispatch();
    const authState = useSelector((state: RootState) => state.auth);

    const [checkerInterval, setCheckerInterval] = useState(null);
    const [loading, setLoading] = useState(false);

    const checkExpiresAt = () => {
        let expiresAt = moment(new Date(authState.expiresAt));
        let secondsLeft = moment().diff(expiresAt, 'seconds') * -1;
        let secondsLastAction = moment().diff(moment(authState.lastActionAt), 'seconds');
        if (secondsLeft < refreshAt) {
            if (secondsLastAction < stayLoggedInUntil) {
                if (!loading) {
                    getNewAccessToken();
                }
            }
        }
    };

    useEffect(() => {
        if (!checkerInterval) {
            let interval = setInterval(checkExpiresAt, 10000);
            setCheckerInterval(interval);
        }

        return function cleanup() {
            if (checkerInterval) {
                clearInterval(checkerInterval);
                setCheckerInterval(null);
            }
        };
    }, [checkerInterval, authState.expiresAt, authState.lastActionAt]);

    const getNewAccessToken = () => {
        setLoading(true);
        refreshAccessToken({ refreshToken: authState.refreshToken })
            .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                    dispatch(
                        accessTokenSuccess({
                            accessToken: response.data.access_token,
                            expiresAt: response.data.expires_at,
                            refreshToken: response.data.refresh_token,
                            refreshTokenExpiresAt: response.data.refresh_token_expires_at,
                        })
                    );
                } else {
                    dispatch(logout());
                }
            })
            .catch((error) => {
                dispatch(logout());
            });
    };

    return null;
};

export default LoginHelper;
